export { sendCrashEvent } from './src/sendCrashEvent';
export { sendErrorEvent } from './src/sendErrorEvent';
export { startSession } from './src/startSession';
export { getSessionId } from './src/getSessionId';
